export default __webpack_public_path__ + "static/media/1.ced17f70.png";